$(function () {
  fadein();
  week_swiper();
  /*  フェードイン
  ---------------------------------------------------*/
  function fadein() {
    $(function () {
      // load時とscroll時に同じ処理を行う
      $(window).on("load scroll", function () {
        var windowHeight = $(window).height(),
          scrollY = $(window).scrollTop();

        // 通常のfadein
        $(".scroll-fadein").each(function () {
          var thisPosition = $(this).offset().top;
          if (scrollY > thisPosition - windowHeight) {
            $(this).addClass("fadein-animation-start");
          }
        });

        // scroll-fadein-lgの場合
        $(".scroll-fadein-lg").each(function () {
          var thisPosition = $(this).offset().top;
          if (scrollY > thisPosition - windowHeight) {
            $(this).addClass("fadein-animation-start-lg");
          }
        });
      });
    });
  }
  /*  TOPスライダー　swiper
  ---------------------------------------------------*/
  function week_swiper() {
    var swiperWeek = new Swiper(".week-slide", {
      slidesPerView: 1.1,
      spaceBetween: 9,
      centeredSlides: true,
      breakpoints: {
        750: {
          slidesPerView: 1.5,
          spaceBetween: 40,
          centeredSlides: false,
        },
        1024: {
          slidesPerView: 2.1,
          spaceBetween: 40,
          centeredSlides: false,
        },
      },
    });
  }
});

let lastScrollTop = 0;
const headerGroup = document.querySelector(
  ".shopify-section-group-header-group"
);

window.addEventListener(
  "scroll",
  () => {
    let currentScroll =
      window.pageYOffset || document.documentElement.scrollTop;

    // 1. スクロールが一番上付近の時は必ず表示
    if (currentScroll <= 100) {
      headerGroup.classList.remove("is-hidden");
      return;
    }

    // 2. 下スクロールか上スクロールかを判定
    if (currentScroll > lastScrollTop) {
      // 下スクロール中：隠す
      headerGroup.classList.add("is-hidden");
    } else {
      // 上スクロール中：出す
      headerGroup.classList.remove("is-hidden");
    }

    // 現在の値を保存して次回と比較する
    lastScrollTop = currentScroll <= 0 ? 0 : currentScroll;
  },
  false
);

/*  ヘッダーの色変更
---------------------------------------------------*/
document.addEventListener("DOMContentLoaded", function () {
  const header = document.querySelector(".shopify-section-group-header-group");

  // トップページ判定用のクラス（サイトに合わせて変更してください）
  // 例: WordPressなら 'home' や 'front-page' など
  // const isTopPage = document.body.classList.contains('template-index');

  // もしトップページじゃなければ、最初からブレンドモードをつけておく場合
  // if (!isTopPage) {
  //     header.classList.add('is-header-scroll');
  //     return; // ここで処理終了（スクロール監視しない）
  // }

  // --- ここからトップページ用の処理 ---

  function checkScroll() {
    // スクロール量が0より大きければクラスをつける
    if (window.scrollY > 0) {
      header.classList.add("is-header-scroll");
    } else {
      // 最上部に戻ったらクラスを外す
      header.classList.remove("is-header-scroll");
    }
  }

  // スクロール時と、ロード時（リロード対策）に実行
  window.addEventListener("scroll", checkScroll);
  checkScroll();
});

/*  ↓ BEEKEEPERページヘッダー用 ↓
---------------------------------------------------*/
document.addEventListener("DOMContentLoaded", () => {
  const isTargetPage = document.querySelector(".handle-beekeeper");
  if (!isTargetPage) return;

  const header = document.querySelector(".header-section");
  const logoImage = document.querySelector(".header-logo__image");

  const newLogoUrl =
    "https://cdn.shopify.com/s/files/1/0786/7501/7946/files/logo-white.svg?v=1763953791";

  if (logoImage && header) {
    const originalSrc = logoImage.src;
    const originalSrcset = logoImage.srcset;

    const updateLogo = () => {
      const isNotScrolled = !header.classList.contains("is-header-scroll");

      if (isNotScrolled) {
        if (logoImage.src !== newLogoUrl) {
          logoImage.src = newLogoUrl;
          logoImage.srcset = "";
        }
      } else {
        if (logoImage.src !== originalSrc) {
          logoImage.src = originalSrc;
          logoImage.srcset = originalSrcset;
        }
      }
    };
    updateLogo();

    const observer = new MutationObserver(() => {
      updateLogo();
    });
    observer.observe(header, {
      attributes: true,
      attributeFilter: ["class"],
    });
    observer.observe(logoImage, {
      attributes: true,
      attributeFilter: ["src", "srcset"],
    });
  }
});
/*  ↑ BEEKEEPERページヘッダー用 ↑
---------------------------------------------------*/
